import AUValidationSchema from 'modules/addons/components/digital-onboarding/PPSRRegistration/forms/validationSchema/AUValidationSchema';
import NZValidationSchema from 'modules/addons/components/digital-onboarding/PPSRRegistration/forms/validationSchema/NZValidationSchema';

export { NZValidationSchema };
export { AUValidationSchema };
